import { type TextareaHTMLAttributes, forwardRef, useId } from 'react';
import { cn } from '@/lib/utils';
import { Field, controlClasses } from './field';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  wrapperClassName?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, wrapperClassName, label, error, helperText, ...props }, ref) => {
    const generatedId = useId();
    const id = props.id ?? generatedId;
    const descriptionId = error || helperText ? `${id}-description` : undefined;

    return (
      <Field id={id} label={label} error={error} helperText={helperText} descriptionId={descriptionId} className={wrapperClassName}>
        <textarea
          ref={ref}
          id={id}
          aria-invalid={error ? true : undefined}
          aria-describedby={descriptionId}
          className={cn(controlClasses, 'min-h-24 resize-y px-3 py-2 leading-relaxed', className)}
          {...props}
        />
      </Field>
    );
  }
);

Textarea.displayName = 'Textarea';
